import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFireAuth } from 'angularfire2/auth';

@Component({
  selector: 'app-eula',
  templateUrl: './eula.component.html',
  styleUrls: ['./eula.component.css']
})
export class EulaComponent implements OnInit {

  private title: string;
  private body: string;
  constructor(private afs: AngularFirestore, private auth: AngularFireAuth) {
    this.title = 'Persetujuan Pengguna Akhir';
    this.body = '<h3>Loading</h3>';
   }

  ngOnInit() {
    this.afs.collection('assets').doc('MyAEVnqLN6s3Zjvyj4EW').ref.get().then(doc => {
      this.body = doc.get('eula');
    }).catch(e => {

    });
  }

  accept() {
    const profiles = this.afs.collection('profiles').doc(this.auth.auth.currentUser.uid);
    profiles.set({
      eula : true
    });
  }

  reject() {
    this.auth.auth.signOut();
  }

}



// WEBPACK FOOTER //
// ./src/app/eula/eula.component.ts